import { type FC, type ReactNode } from "react";
import { ChevronLeft } from "lucide-react";

import { Button } from "@/shared/components/ui/button";
import logoWhite from "@/shared/assets/logo/logo-white.svg";

interface SplitLayoutProps {
  children: ReactNode;
  imageSrc?: string;
  showMobileImage?: boolean;
  onBack?: () => void;
}

export const SplitLayout: FC<SplitLayoutProps> = ({
  children,
  imageSrc,
  showMobileImage,
  onBack,
}) => {
  return (
    <div className="grid h-full lg:grid-cols-[45fr_55fr]">
      <div className="relative hidden h-full bg-white lg:block">
        {imageSrc && (
          <img
            src={imageSrc}
            alt="Background illustration"
            className="h-full w-full object-cover"
          />
        )}
        <img
          src={logoWhite}
          alt="Elayne"
          className="absolute bottom-16 left-1/2 h-10 -translate-x-1/2"
        />
      </div>

      <div className="flex h-full flex-col bg-subtle">
        {showMobileImage && imageSrc && (
          <div className="lg:hidden">
            <img
              src={imageSrc}
              alt="Background illustration"
              className="h-48 w-full object-cover"
            />
          </div>
        )}
        {onBack && (
          <div className="shrink-0 px-4 py-4 sm:px-6 sm:py-6">
            <Button variant="outline" onClick={onBack}>
              <ChevronLeft className="h-4 w-4" />
              <span className="hidden sm:inline">Back</span>
            </Button>
          </div>
        )}
        <div className="flex-1 overflow-y-auto">
          <div className="flex min-h-full justify-center px-4 py-8 sm:px-6 sm:py-12 lg:items-center">
            <div className="w-full max-w-lg">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
